import { logDebugging, logError } from '../../../log/logger';
import { isMobile } from '../../../utils/browserUtils';
import PlayerError from '../../errors/PlayerError';
import YoutubePlayerListeners from './YoutubePlayerListeners';

export default class YoutubePlayerController {
  constructor(youtubePlayer) {
    this.youtubePlayer = youtubePlayer || null;
    this.handler = new YoutubePlayerListeners(youtubePlayer);
  }

  // eslint-disable-next-line class-methods-use-this
  initialize() {}

  start() {
    this.youtubePlayer.playVideo();
  }

  load(urlVideo) {
    this.autoPlayForMobile();
    this.youtubePlayer.setVideoYoutubeId(urlVideo);
    this.youtubePlayer.insert();
    this.handler = new YoutubePlayerListeners(this.idComponet, this.youtubePlayer);
  }

  autoPlayForMobile() {
    if (!isMobile()) {
      this.youtubePlayer.setAutoPlay(true);
    }
  }

  skip() {
    this.remove();
    this.handler.skip();
  }

  replay() {
    this.handler.replay();
  }

  remove() {
    logDebugging('remove youtube object');
    if (this.handler) this.handler.clearIntervalTime();
    if (this.youtubePlayer) this.youtubePlayer.destroy();
    this.youtubePlayer = null;
  }

  play(time) {
    if (time) {
      this.youtubePlayer.seekTo(time, true);
    }

    this.youtubePlayer?.playVideo();
  }

  pause() {
    this.youtubePlayer?.pauseVideo();
  }

  resume() {
    this.youtubePlayer?.playVideo();
  }

  getVolume() {
    return this.youtubePlayer.getVolume();
  }

  setVolume(vol) {
    let volumeLevel = vol;
    if (vol <= 0) {
      volumeLevel = 0;
    } else if (vol >= 1) {
      volumeLevel = 1;
    }
    this.youtubePlayer.setVolume(volumeLevel * 100);
  }

  mute() {
    try {
      this.youtubePlayer.mute();
      this.youtubePlayer.setVolume(0);
    } catch (err) {
      logDebugging('[YoutubePlayerController] error in mute function');
    }
  }

  unmute() {
    this.youtubePlayer.unMute();
    this.setVolume(1);
  }

  getDuration() {
    return this.youtubePlayer.getDuration();
  }

  getCurrentTime() {
    return this.youtubePlayer.getCurrentTime();
  }

  isMetadataLoaded() {
    return this.getDuration() && this.getDuration() > 0;
  }

  showControls(value) {
    this.youtubePlayer.displayControls(value);
  }

  setAutoPlay(value) {
    this.youtubePlayer.setAutoPlay(value);
  }

  seekTo(percent) {
    this.youtubePlayer.seekTo((percent * this.getDuration()) / 100, true);
  }

  getAvailableQualityLevels() {
    let aux = [];
    try {
      if (this.youtubePlayer != null) {
        aux = this.youtubePlayer.getAvailableQualityLevels();
        return aux;
      }
    } catch (error) {
      return aux;
    }
    return aux;
  }

  getPlaybackQuality() {
    let aux = '';
    try {
      if (this.youtubePlayer != null) {
        aux = this.youtubePlayer.getPlaybackQuality();
        return aux;
      }
    } catch (error) {
      return aux;
    }
    return aux;
  }

  setPlaybackQuality(value) {
    try {
      if (this.youtubePlayer != null) {
        this.youtubePlayer.setPlaybackQuality(value);
      }
    } catch (error) {
      logError('error to setPlaybackQuality');
    }
  }

  getEvent() {
    try {
      return this.handler.youtubePlayerEvent;
    } catch (error) {
      throw new PlayerError('[YoutubePlayerController] No se han podido capturar los eventos');
    }
  }

  resize() {
    logDebugging('[YoutubePlayerController] resize', this.youtubePlayer);
  }
}
